<script setup lang="ts">

import FaIcon from '@/application/components/ui/FaIcon.vue';
import { ElTooltip } from 'element-plus';
</script>

<template>
  <ElTooltip
    content="Ausgefüllt vom KI Assistenten"
    placement="top-end"
  >
    <FaIcon
      name="sparkles"
      variant="regular"
      size="sm"
      class="text-blue-500 cursor-help"
    />
  </ElTooltip>
</template>
